module.exports = __webpack_public_path__ + "img/speaker-JodyAvirgan.72e99ad9.png";